<template>
  <tr
    :key="index"
    :style="{ cursor: 'pointer' }"
    :class="selectedRow === index ? 'indigo lighten-5' : ''"
    @click="selectRow(index)"
  >
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.trx_pan }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.invoice_number }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.merchant_name }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.mid }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.mpan }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.rrn }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.trx_type }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.issuer_name }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.customer_pan }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.payment_type }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.payment_channel }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.amount }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.amount_mdr }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.amount_net }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.trx_datetime }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.status }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.settlement_status }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      <v-icon small class="mr-2" @click="viewItem(item.id)"> mdi-eye </v-icon>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['options', 'selectedRow', 'item', 'index'],
  methods: {
    selectRow(index) {
      this.$emit('selectRowParent', index);
    },
    shortingText(text, length) {
      if (!text) {
        return '';
      }
      if (text.length <= length) {
        return text;
      }
      return `${text.slice(0, length)}...`;
    },
    viewItem(itemId) {
      this.$emit('viewItemParent', itemId);
    },
  },
};
</script>
